import PropTypes from 'prop-types';

export const itemShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string,
  isActive: PropTypes.bool,
});
